import React from "react";
import {
  Button,
  Col,
  Row,
  Input,
  Spinner,
  Navbar,
  Nav,
  NavLink,
  CustomInput,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import radioButton from "../../assets/radioButton.svg";
import radioButtonhighlighted from "../../assets/radioButtonhighlighted.svg";
import {
  fetchFilterOptions,
  fetchBuilding,
  fetchFloors,
  fetchSpeciesTypes,
  fetchLocationResultsBiomeTrackingData,
  downloadSampleData,
} from "../../actions";
import { NavLink as RRNavLink } from "react-router-dom";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-input-range/lib/css/index.css";
import InputRange from "react-input-range";
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import "./speciesResults.css";
import SpeciesDensityTracking from "../SpeciesDensityTracking/densityTracking";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NavBar from "../../components/NavBar/navBar";
import Tour from "../../Tour";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin, appInsights } from "../../AppInsights";
import { SeverityLevel } from "@microsoft/applicationinsights-common";

let errorDetails = "";
let building = sessionStorage.getItem("building");
let buildingId = sessionStorage.getItem("buildingId");
let buildingName = sessionStorage.getItem("buildingName");
let floor = sessionStorage.getItem("floor");
let floorId = sessionStorage.getItem("floorId");
let floorName = sessionStorage.getItem("floorName");
const initialState = {
  resultBuilding: building ? building : "",
  resultFloor: floor ? floor : "",
  fromDate: "",
  toDate: "",
  filterspeciesList: [],
  buildingId: buildingId ? buildingId : "",
  floorId: floorId ? floorId : "",
  speciesType: "",
  show: false,
  checkbox: true,
  isOpen: false,
  resultBatchNo: "",
  resultSampleType: "",
  Disable: localStorage.getItem("guest") ? false : true,
  key: 1,
  alert: false,
  loader: false,
  maxDays: 0,
  dateRange: {
    min: 0,
    max: 0,
  },
};
const colors = ["#f58026", "#0f61f5", "#00d168", "#7548c7", "#f53a1b"];
class SpeciesResults extends React.Component {
  constructor(props) {
    super(props);
    this.props.fetchFilterOptions();
    this.props.fetchBuilding();
    this.applyFilter = this.applyFilter.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onChangeFromDate = this.onChangeFromDate.bind(this);
    this.onChangeToDate = this.onChangeToDate.bind(this);

    building = sessionStorage.getItem("building");
    buildingId = sessionStorage.getItem("buildingId");
    floor = sessionStorage.getItem("floor");
    floorId = sessionStorage.getItem("floorId");
    let floorInitialState = {
      resultBuilding: building
        ? building
        : localStorage.getItem("guest")
          ? "BldgA"
          : "",
      resultFloor: floor ? floor : localStorage.getItem("guest") ? 20000 : "",
      floorId: floorId ? floorId : localStorage.getItem("guest") ? 20000 : "",
      buildingId: buildingId
        ? buildingId
        : localStorage.getItem("guest")
          ? 20000
          : "",
      buildingName: buildingName
        ? buildingName
        : localStorage.getItem("guest")
          ? "Region A"
          : "",
      floorName: floorName
        ? floorName
        : localStorage.getItem("guest")
          ? "Map A"
          : "",
    };
    
    this.initialState = this.props.initialState;
    this.state = {
      ...initialState,
      ...floorInitialState,
      speciesList: props.speciesList,
    };
    
    if (localStorage.getItem("guest")) {
      setTimeout(() => {
        this.getSpeciesTypes();
        let data = [];
        this.props.speciesList.speciesList.forEach((item, index) => {
          if (
            this.props.speciesList.speciesList.length > 1 &&
            this.props.speciesList.speciesList.length - index <= 1
          )
            return data.push(item[0]);
          else if (this.props.speciesList.speciesList.length <= 1)
            return data.push(item[0]);
        });
        this.setState({ filterspeciesList: data, speciesFilter: data });
      });
    }
  }

  componentDidMount() {
    let diffDate = this.state.toDate - this.state.fromDate;
    let count = Math.ceil(diffDate / (1000 * 60 * 60 * 24));
    this.setState({
      maxDays: count,
      dateRange: {
        ...this.state.dateRange,
        max: count,
        min: 0,
      },
    });


    // Below function calls are for the automatic setting of values on load
    this.props.fetchBuilding().then(() => {
      this.onSelectBuilding("", 'onMount')
      this.onSelectFloor("","onMount")
      this.onChangeToDate()
      let data = {
        floor_id: this.state.resultFloor,
      };
      if(this.state.resultFloor){
        this.props.fetchSpeciesTypes({ data }).then(() => {
          this.setState({
            speciesFilter: [this.props.speciesList.speciesMaxCount],
            filterspeciesList: this.props.speciesList.speciesMaxCount,
            speciesType: this.props.speciesList.speciesMaxCount,
          })
          this.props.downloadSampleData().then(() => {
            this.onChangeFromDate()
            if(this.state.speciesType){
              this.applyFilter()
            }
          })
        })
      }
    })
  }

  ErrorDetails = () => {
    appInsights.trackTrace({
      message: errorDetails,
      properties: { page: "trackResults" },
      severityLevel: SeverityLevel.Verbose,
    });
    if(window.location.pathname.includes('/results/speciesdensity/') || window.location.pathname.includes('/results/speciesdensity')){
      toast.error(errorDetails, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
        errorDetails = "";
    return true;
  };

  handleOptionChange = (name, name2) => (event) => {
    if (event.target.value != null) {
      this.setState({
        [name]: [event.target.value],
        [name2]: event.target.value,
        speciesType: event.target.value,
        alert: false,
        show: false,
      });
    } else {
      if (event.target.value == null) {
        let message = "Please select sepcies";
        appInsights.trackException({
          exception: new Error(message),
          name: "Complex Type Selection",
          user: localStorage.getItem("userName"),
          severityLevel: SeverityLevel.Information,
        });
        this.setState({
          alert: true,
        });
        setTimeout(() => {
          this.setState({ alert: false });
        }, 3000);
      }
    }
  };

  getfilters = (filterList) => {
    let arr = [];
    let filter = filterList ? filterList["speciesList"] : [];
    if (filter) {
      filter.forEach((data) => {
        arr.push(data);
      });
    }
    return arr;
  };


  getEarliestDate() {
    let data = this.props.sampleData
    let dates = []
    let max_date
    if(data.length>0){
      for(let value of data){
        dates.push(value['date_time'].split('T')[0])
      }
        max_date = dates.reduce(function (a, b) { return a < b ? a : b; });      
   }
    else{
        max_date = moment.utc(new Date(new Date().setFullYear(new Date().getFullYear() - 2)))['_d']
    }
  return (max_date)
  }

  onSelectBuilding = (event, flag = false) => {
    if (flag === false) {
      const { value, selectedOptions } = event.target;
      sessionStorage.setItem("building", value);
      sessionStorage.setItem("buildingId", selectedOptions[0].id);
      sessionStorage.setItem("buildingName", selectedOptions[0].innerText);
      sessionStorage.setItem("floor", "");
      sessionStorage.setItem("floorId", "");
      sessionStorage.setItem("floorName", "");
    }
    else if (flag == "onMount" 
      && this.props.buildingList 
      && this.props.buildingList.length>0
      ){
      sessionStorage.setItem("building", this.props.buildingList[0]['building_id'])
      sessionStorage.setItem("buildingId", this.props.buildingList[0]['id'])
      sessionStorage.setItem("buildingName", this.props.buildingList[0]['building_name'])
      if(this.props.buildingList[0]['floors'].length==0){
        sessionStorage.setItem("floorName","")
        sessionStorage.setItem("floorId","")
        sessionStorage.setItem("floor","")
      }
    }

    // This if is to toggle between reseting the speciesFilter and speciesType variables
    if(!(flag=="onMount" 
    && this.props.buildingList 
    && this.props.buildingList.length>0
    )){
      this.setState({
        speciesFilter: [],
        speciesType: "",
      })
    }  
      this.setState(
        (prevState) => ({
          ...this.state,
          resultBuilding: sessionStorage.getItem("building") != null ? sessionStorage.getItem("building") : this.props.buildingList && this.props.buildingList.length>0? this.props.buildingList[0]['building_id']:'',
          buildingId: sessionStorage.getItem("buildingId") != null ? sessionStorage.getItem("buildingId") : this.props.buildingList && this.props.buildingList.length>0? this.props.buildingList[0]['id']:'',
          buildingName: sessionStorage.getItem("buildingName") != null ? sessionStorage.getItem("buildingName") : this.props.buildingList && this.props.buildingList.length>0? this.props.buildingList[0]['building_name']:'',
          resultFloor: "",
          floorId: flag ? prevState.floorId : "",
          floorName: flag ? prevState.floorName : "",
          areas: flag ? prevState.areas : [],
          floor_plan: flag ? prevState.floor_plan : "",
          show: false, 
        }),
        async () => {
          await this.props.fetchFloors(this.state.buildingId);
          if (sessionStorage.getItem("floor") || sessionStorage.getItem('floor') == null) await this.onSelectFloor("", "onMount");
        }
      );
  };

  onSelectFloor = (event, flag = false) => {
    if (flag === false) {
      const { value, selectedOptions } = event.target;
      sessionStorage.setItem("floorName", selectedOptions[0].innerText);
      sessionStorage.setItem("floorId", selectedOptions[0].id);
      sessionStorage.setItem("floor", value);
    }
    else if (flag == "onMount" 
      && this.props.buildingList 
      && this.props.buildingList.length>0
      && this.props.buildingList[0]['floors']
      && this.props.buildingList[0]['floors'].length>0){
      sessionStorage.setItem("floorName", this.props.buildingList[0]['floors'][0]['floor_name'])
      sessionStorage.setItem("floorId", this.props.buildingList[0]['floors'][0]['id'])
      sessionStorage.setItem("floor", this.props.buildingList[0]['floors'][0]['id'])
    }
    
    // This if is to toggle between reseting the speciesFilter and speciesType variables
    if(!(flag=="onMount"  && this.props.buildingList 
    && this.props.buildingList.length>0 && this.props.buildingList[0]['floors']
    && this.props.buildingList[0]['floors'].length>0)){
      this.setState({
        speciesType: "",
      })
    }
    this.setState(
      (prevState) => ({
        ...this.state,
        resultFloor: sessionStorage.getItem("floor") ? sessionStorage.getItem("floor") : this.props.buildingList ? this.props.buildingList.length>0? this.props.buildingList[0]['floors'].length>0?  this.props.buildingList[0]['floors'][0]['id']:'':'':'',
        floorId: sessionStorage.getItem("floorId") ? sessionStorage.getItem("floorId") : this.props.buildingList ? this.props.buildingList.length>0? this.props.buildingList[0]['floors'].length>0?  this.props.buildingList[0]['floors'][0]['id']:'':'':'',
        floorName: sessionStorage.getItem("floorName") ? sessionStorage.getItem("floorName") : this.props.buildingList ? this.props.buildingList.length>0? this.props.buildingList[0]['floors'].length>0?  this.props.buildingList[0]['floors'][0]['floor_name']:'':'':'',
        show: false,
        floor_plan: flag ? prevState.floor_plan : "",
      }),
      () => {
        this.getSpeciesTypes();
      }
    );
  };

  lableDateGenerator = (dateCount) => {
    var dateGenerator = new Date(this.state.fromDate);
    dateGenerator.setDate(dateGenerator.getDate() + dateCount);
    return dateGenerator.toDateString();
  };

  getSpeciesTypes = () => {
    if (
      this.state.resultFloor &&
      this.state.resultBuilding
    ) {
      this.setState({ Disable: false });
      var data = {
        floor_id: this.state.resultFloor,
      };
      this.props.fetchSpeciesTypes({ data })
    }
  };

  onSelect = (event) => {
    this.setState(
      {
        ...this.state,
        [event.target.name]: event.target.value,
        show: false,
        filterspeciesList: [],
        speciesFilter: [],
      },
      () => {
        this.getSpeciesTypes();
      }
    );
  };

  toggle(event) {
    this.setState({
      ctCheckboxMapping: {
        ...this.state.ctCheckboxMapping,
        [event.target.name]: !this.state.ctCheckboxMapping[event.target.name],
      },
      key: this.state.key + 1,
    });
  }

  fetchLocationAreas = (data, ct_checkbox_mapping, ct_color_mapping) => {
    this.setState({ loader: true });
    this.props.fetchLocationResultsBiomeTrackingData(data).then((response) => {
      if (response.status === 200) {
        if ("locations_data" in response.data) {
          appInsights.trackTrace({
            message: "Flooplan and Location Data is fetched successfully",
            properties: {
              page: "trackResults",
              name: response.data.locations_data.floor_data.floor_name,
              id: this.state.floorId,
              speciesType: this.state.speciesFilter,
            },
            severityLevel: SeverityLevel.Information,
          });
          this.setState({
            resultsData: response.data.locations_data,
            speciesTypeFilter: this.state.speciesFilter,
            key: this.state.key + 1,
            show: true,
            loader: false,
            ctColorMapping: ct_color_mapping,
            ctCheckboxMapping: ct_checkbox_mapping,
          });
        }
      } else {
        this.setState({ loader: false });
        let message = "Errors in loading locations data!";
        appInsights.trackTrace({
          message: message,
          properties: {
            page: "trackResults",
            name: this.state.floorName,
            id: this.state.floorId,
            speciesType: this.state.speciesFilter,
          },
          severityLevel: SeverityLevel.Error,
        });
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    })
      .catch((error) => {
        this.setState({ loader: false });
        let message = "Errors in loading locations data!";
        appInsights.trackTrace({
          message: message,
          properties: {
            page: "trackResults",
            name: this.state.floorName,
            id: this.state.floorId,
            speciesType: this.state.speciesFilter,
            error: error,
          },
          severityLevel: SeverityLevel.Error,
        });
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  applyFilter = () => {
    if (this.isvalidData(this.state)) {
      var data = {
        type_of_samples: this.state.resultSampleType,
        date_time_after: moment.utc(new Date(this.state.fromDate)).format("YYYY-MM-DD"),
        date_time_before: moment.utc(new Date(this.state.toDate)).format("YYYY-MM-DD"),
        batch_no: this.state.resultBatchNo,
        building: this.state.buildingId,
        species_type: this.state.speciesType
          ? this.props.speciesList
          ? this.props.speciesList['speciesList'] && this.props.speciesList['speciesList'].length>0
          ? this.props.speciesList['speciesList'].indexOf(this.state.speciesType) >= 0 ?
            this.state.speciesType.toString()
          : ''
          : ""
          : ''
          :'',
      };

      let ct_color_mapping = {};
      let ct_checkbox_mapping = {};
      this.state.speciesFilter.forEach((ct, i) => {
        ct_color_mapping[ct] = colors[i];
        ct_checkbox_mapping[ct] = true;
      });

      data.floor__id = this.state.floorId;
      this.fetchLocationAreas(data, ct_checkbox_mapping, ct_color_mapping);

      let diffDate = this.state.toDate - this.state.fromDate;
      let count = Math.ceil(diffDate / (1000 * 60 * 60 * 24));
      this.setState({
        maxDays: count,
        dateRange: {
          ...this.state.dateRange,
          max: count,
          min: 0,
        },
      });
    } else {
      this.ErrorDetails();
      this.setState({
        resultsData: [],
        resultsTimelineData: [],
      });
    }
  };

  isvalidData = (data) => {
    let speciesSelectedLength = data.speciesFilter ? data.speciesFilter[0]!=='' || data.speciesFilter[0].length!=0? this.props.speciesList['speciesList'].indexOf(data.speciesType) >= 0 ? data.speciesFilter.length : 0 : 0 : 0;
    if (data.buildingId && data.floorId && speciesSelectedLength > 0 && data.fromDate && data.toDate) {
      if (data.fromDate.setHours(0, 0, 0, 0) <= data.toDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      else {
        errorDetails = "Please select an appropriate Date range!";
        return false;
      }
    }
    else if (!data.buildingId) {
      errorDetails = "Please select a Building!";
      return false;
    }
    else if (!data.floorId) {
      errorDetails = "Please select a Floor!";
      return false;
    }
    else if (speciesSelectedLength <= 0 || !this.props.speciesList['speciesList'].indexOf(data.speciesType) >= 0) {
      errorDetails = "Please select a Species!";
      return false;
    }
    else if (!data.fromDate) {
      errorDetails = "Please select a Start Date!";
      return false;
    }
    else if (!data.toDate) {
      errorDetails = "Please select an End Date!";
      return false;
    }
  };

  getDatetime = (date) => {
    let datetime = new Date();

    datetime.setDate(date.getDate());
    datetime.setMonth(date.getMonth());
    datetime.setFullYear(date.getFullYear());

    return datetime;
  };

  onChangeFromDate = (date) => {
    if (date === undefined) {
      this.setState(
        {
          fromDate: this.getDatetime(moment.utc(new Date(this.getEarliestDate()))['_d']),
          show: false,
          filterspeciesList: [],
        },
        () => {
          this.getSpeciesTypes();
        }
      );

    }
    else {
      this.setState(
        {
          fromDate: this.getDatetime(date),
          show: false,
          filterspeciesList: [],
        },
        () => {
          this.getSpeciesTypes();
        }
      );
    }
  };

  onChangeToDate = (date) => {
    if (date === undefined) {
      this.setState(
        {
          toDate: this.getDatetime(moment.utc(new Date())['_d']),
          show: false,
          filterspeciesList: [],
        },
        () => {
          this.getSpeciesTypes();
        }
      );
    }
    else {
      this.setState(
        {
          toDate: this.getDatetime(date),
          show: false,
          filterspeciesList: [],
        },
        () => {
          this.getSpeciesTypes();
        }
      );
    }
  };

  handleValueChange = (event) => {
    this.setState({
      ...this.state,
      [event.target.name]: event.currentTarget.value,
    });
  };

  checkBox = () => {
    this.setState((prevState) => ({
      checkbox: !prevState.checkbox,
    }));
  };

  resetData = () => {
    this.setState(
      {
        ...initialState,
        organismFilter: [],
        speciesFilter: [],
        speciesType: "",
        isOpen: this.state.isOpen,
        resultsData: [],
        floorName: '',
        floorId: '',
        buildingName: '',
        resultBuilding: '',
        resultFloor: '',
        buildingId: '',
        resultsTimelineData: [],
      });
    window.sessionStorage.removeItem('buildingId')
    window.sessionStorage.removeItem('buildingName')
    window.sessionStorage.removeItem('building')
    window.sessionStorage.removeItem('floorName')
    window.sessionStorage.removeItem('floorId')
    window.sessionStorage.removeItem('floor')
  };

  render() {
    return (
      <div data-tut="reactour__results" className="page-layout">
        <NavBar />
        <div className="dashboard-overview results-page">
          <div
            className="dashboard-content-25"
            ref={(divElement) => {
              this.divElement = divElement;
            }}
          >
            <Row className="sample-list-header" form>
              <Navbar className="navbar-results " light expand="md">
                <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/viewresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />All Results</span></NavLink>
                <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/trackresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />Track Result</span></NavLink>
                <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/snpresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />SNP Result</span></NavLink>
                <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/biomeresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />Microbiome Result</span></NavLink>
                <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding bottom-border" activeClassName="active" to="/results/speciesdensity/"><span className="nav-col"><img src={radioButtonhighlighted} className="nav-icons" alt="" />Species Density</span></NavLink>
              </Navbar>
            </Row>
            <div className="sample-input-area" data-tut="reactour__apply">
              <Row form>
                <Col sm={4} md={3} lg={2}>
                  <Input
                    className={
                      this.state.resultBuilding
                        ? this.props.sideBarHover? "sample-input-fields no-display":"sample-input-fields"
                        : this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"
                    }
                    id="trackBuilding"
                    type="select"
                    name="resultBuilding"
                    value={this.state.resultBuilding}
                    onChange={this.onSelectBuilding}
                    size="1"
                  >
                    <option value="" default disabled>
                      Building*
                    </option>
                    {this.props.buildingList.map((building, key) => {
                      return (
                        <option
                          className="dashboard-options"
                          id={building.id}
                          key={key}
                          value={building.building_id}
                        >
                          {building.building_name}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
                <Col sm={4} md={3} lg={2}>
                  <Input
                    className={
                      this.state.resultFloor
                        ? this.props.sideBarHover? "sample-input-fields no-display" :"sample-input-fields"
                        : this.props.sideBarHover?  "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"
                    }
                    id="trackFloor"
                    type="select"
                    name="resultFloor"
                    value={this.state.resultFloor}
                    onChange={(e) => this.onSelectFloor(e, false)}
                    size="1"
                  >
                    <option value="" default disabled>
                      Floor*
                    </option>
                    {this.props.floorsList.map((floor, key) => {
                      return (
                        <option
                          className="dashboard-options"
                          id={floor.id}
                          key={key}
                          value={floor.id}
                        >
                          {floor.floor_name}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
                <Col sm={4} md={3} lg={2}>
                  <Input
                    className={
                      this.state.speciesType
                        ? this.props.sideBarHover? "sample-input-fields no-display": "sample-input-fields"
                        : this.props.sideBarHover?"sample-input-fields default-disabled no-display": "sample-input-fields default-disabled"
                    }
                    id="trackSpecies"
                    type="select"
                    name="resultSpecies"
                    value={ this.props.speciesList? this.props.speciesList['speciesList'] && this.props.speciesList['speciesList'].length>0 ?this.props.speciesList['speciesList'].indexOf(this.state.speciesType) >= 0 ? this.state.speciesType : "" : "" :""}
                    onChange={this.handleOptionChange(
                      "speciesFilter",
                      "filterspeciesList"
                    )}
                    size="1"
                  >
                    <option value="" default disabled>
                      Species*
                    </option>
                    {this.getfilters(this.props.speciesList).map((species) => {
                      return (
                        <option
                          className="dashboard-options"
                          id={species}
                          key={species}
                          value={species}
                        >
                          {species}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
                <Col sm={4} md={3} lg={2}>
                  <div>
                    <DatePicker
                      className="sample-input-fields form-control"
                      wrapperClassName="datepicker-wrapper"
                      portalId="root"
                      popperProps={{
                        positionFixed: true,
                      }}
                      id="from-date"
                      selected={this.state.fromDate}
                      onChange={this.onChangeFromDate}
                      filterDate={(date) => {
                        return moment() > date;
                      }}
                      maxDate={new Date()}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      dateFormat="MMMM d, yyyy"
                      dateFormatCalendar=" "
                      placeholderText="From*"
                      autoComplete="off"
                      popperModifiers={{
                        preventOverflow: {
                          enabled: true,
                        },
                      }}
                    />
                  </div>
                  {window.innerWidth > 1500 && (
                    <FontAwesomeIcon
                      className="date-icon-results"
                      icon={faCalendar}
                      size="lg"
                    />
                  )}
                </Col>
                <Col sm={4} md={3} lg={2}>
                  <div>
                    <DatePicker
                      className="sample-input-fields form-control"
                      wrapperClassName="datepicker-wrapper"
                      popperProps={{
                        positionFixed: true,
                      }}
                      portalId="root"
                      id="to-date"
                      selected={this.state.toDate}
                      onChange={this.onChangeToDate}
                      filterDate={(date) => {
                        return moment() > date;
                      }}
                      maxDate={new Date()}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      dateFormat="MMMM d, yyyy"
                      dateFormatCalendar=" "
                      placeholderText="To*"
                      autoComplete="off"
                      popperModifiers={{
                        preventOverflow: {
                          enabled: true,
                        },
                      }}
                    />
                  </div>
                  {window.innerWidth > 1500 && (
                    <FontAwesomeIcon
                      className="date-icon-results"
                      icon={faCalendar}
                      size="lg"
                    />
                  )}
                </Col>
                <Col className="clear-apply-end" data-tut="reactour__apply">
                  <Button
                    className="sample-clear-button"
                    id="clearButton"
                    outline
                    color="secondary"
                    type="reset"
                    onClick={this.resetData}
                  >
                    Clear
                  </Button>
                  <Button
                    id="applyFloorButton"
                    type="submit"
                    onClick={this.applyFilter}
                  >
                    Apply
                    {this.state.loader ? <Spinner className="sample-floor-spinner" /> : null}
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
          <div className="grid-data width" data-tut="reactour__resultView">
            <div>
              {this.state.show ? (
                <div>
                  <Row className="sample-list-header" form>
                    <Col className="align-start">
                      <Navbar className="navbar-results" light expand="md">
                        <Nav navbar data-tut="reactour__nav"></Nav>
                      </Navbar>
                    </Col>
                  </Row>
                  <div
                    className={
                      !this.state.showTimeline
                        ? "d-flex flex-row-forward ct-data"
                        : "d-flex flex-row-forward timeline-ct-data"
                    }
                  >
                    {this.state.ctColorMapping
                      ? Object.entries(this.state.ctColorMapping).map(
                        ([complex, color]) => {
                          return (
                            <CustomInput
                              checked={this.state.ctCheckboxMapping[complex]}
                              className={
                                "ct-checkbox a" + color.split("#")[1]
                              }
                              type="checkbox"
                              id={complex}
                              name={complex}
                              style={{ margin: "5px", color: color }}
                              onChange={this.toggle}
                              label={complex}
                            />
                          );
                        }
                      )
                      : null}
                  </div>
                  {this.state.resultsData !== undefined &&
                    this.state.resultsData.data &&
                    this.state.resultsData.data.length > 0 &&
                    !this.state.showTimeline ? (
                    <SpeciesDensityTracking
                      resultsData={this.state.resultsData}
                      ctColorMapping={this.state.ctColorMapping}
                      ctCheckboxMapping={false}
                      key={this.state.key}
                    ></SpeciesDensityTracking>
                  ) : null}
                </div>
              ) : (
                <>
                  <Row className="sample-list-header" form>
                    <Navbar className="navbar-results" light expand="md">
                      <Nav navbar data-tut="reactour__nav"></Nav>
                    </Navbar>
                  </Row>
                  <div className="no-data-msg results-data">
                    Select above criteria and click on Apply button to view
                    data.{" "}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <ToastContainer autoClose={3000} />
        {this.props.isTourOpen ? (
          <Tour
            isOpen={this.props.isTourOpen}
            closeTour={this.props.closeTour}
            openTour={this.props.openTour}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filters: state.results_data.filters,
    locationList: state.sample_data.locationList,
    buildingList: state.floor_data.buildingsList,
    floorsList: state.floor_data.floorsList,
    initialState: state.results_data.initialState,
    speciesList: state.results_data.speciesList,
    sampleData: state.sample_data.downloadSampleData,
  };
};

export default withAITracking(
  reactPlugin,
  connect(mapStateToProps, {
    fetchFilterOptions,
    fetchBuilding,
    fetchFloors,
    fetchSpeciesTypes,
    fetchLocationResultsBiomeTrackingData,
    downloadSampleData,
  })(SpeciesResults),
  "Species Density",
  "SpeciesResults"
);
